import MonitoringSubFilters from './MonitoringSubFilters';
import MonitoringCommonFilters from './MonitoringCommonFilters';

export const MonitoringFilters = () => {
  return (
    <div className="flex flex-column gap-md">
      <div className="grid nc_filters align-items-center">
        <div className="field col-12 lg:col-2">
          <h4>Report Settings:</h4>
        </div>
        <MonitoringCommonFilters roadmapRequired={false} />
      </div>
      <MonitoringSubFilters />
    </div>
  );
};
